import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { extract } from "@app/core";
import { ContingentPageComponent } from "./contingent-page/contingent-page.component";
import { contingentPageGuard } from "./contingent-page.guard";
import { DetailedPageComponent } from "./detailed-page/detailed-page.component";
import { projectDashboardPageGuard } from "./projecthours-page.guard";
import { ReportsComponent } from "./reports.component";
import { ReportsPageGuard } from "./reports-page.guard";
import { SchedulesPageComponent } from "./schedules-page/schedules-page.component";
import SchedulesPageGuard from "./schedules-page/schedules-page.guard";
import { SummaryPageComponent } from "./summary-page/summary-page.component";

const routes: Routes = [
	// Module is lazy loaded, see app-routing.module.ts
	{
		path: "",
		component: ReportsComponent,
		canActivate: [ReportsPageGuard],
		canActivateChild: [ReportsPageGuard],
		children: [
			{
				path: "",
				component: SummaryPageComponent,
				data: { title: "reports.summary" },
				canActivate: [projectDashboardPageGuard],
			},
			{
				path: "detailed",
				component: DetailedPageComponent,
				data: { title: "reports.detailed" },
				canActivate: [projectDashboardPageGuard],
			},
			{
				path: "schedules",
				component: SchedulesPageComponent,
				data: { title: "reports.schedule" },
				canActivate: [SchedulesPageGuard],
			},
			{
				path: "contingent",
				component: ContingentPageComponent,
				canActivate: [contingentPageGuard],
				data: { title: "reports.contingent" },
			},
		],
		data: { title: extract("Reports") },
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
	providers: [],
})
export class ReportsRoutingModule {}
